import { render, staticRenderFns } from "./DraggableItems.vue?vue&type=template&id=2c30e280&"
import script from "./DraggableItems.vue?vue&type=script&lang=js&"
export * from "./DraggableItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports